<template>
  <a-card bordered>
    <span slot="title">
      <a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
      Bank Account
    </span>

    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Date" prop="date">
            <a-input disabled v-model="form.date" />
          </a-form-model-item>
          <a-row :gutter="6">
            <a-col span="12">
              <a-form-model-item
                label="Bank Account Name"
                prop="bank_account_name"
              >
                <a-auto-complete
                  :disabled="mode == 'Edit'"
                  v-model="form.bank_account_name"
                  :data-source="bank"
                  :filter-option="filterOption"
                />
              </a-form-model-item>
            </a-col>
            <a-col span="12">
              <a-form-model-item label="Bank Code" prop="bank_code">
                <a-input :disabled="mode == 'Edit'" v-model="form.bank_code" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item label="Owner" prop="owner">
            <a-input v-model="form.owner" />
          </a-form-model-item>
          <a-row :gutter="6">
            <a-col span="12">
              <a-form-model-item label="Currency" prop="currency">
                <a-select :disabled="mode == 'Edit'" v-model="form.currency">
                  <a-select-option
                    v-for="item in currency"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col span="12">
              <a-form-model-item label="Rekening No" prop="rekening_no">
                <a-input :disabled="mode == 'Edit'" v-model="form.rekening_no" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="Balance" prop="balance">
            <a-input-number
              :disabled="mode=='Edit'"
              class="m-width-full"
              v-model="form.balance"
              @keydown="onlyNumber"
              :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Swift Code" prop="swift_code">
            <a-input v-model="form.swift_code" />
          
        </a-form-model-item>
          <a-form-model-item label="Address" prop="address">
            <a-textarea v-model="form.address"></a-textarea>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="action">
      <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
    </div>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "bank-account-create",
  props: ["id"],
  mixins: [GlobalMethod],
  data() {
    return {
      mode: "Create",
      loading: {
        submit: false,
      },
      form: {
        date: null,
        bank_account_name: null,
        bank_code: null,
        owner: null,
        currency: null,
        rekening_no: null,
        balance: 0,
        swift_code: null,
        address: null,
      },
      dataedit: {},
      rules: {
        bank_account_name: {
          required: true,
          message: "Please input bank account name",
          trigger: "change",
        },
        bank_code: {
          required: true,
          message: "Please input bank code",
          trigger: "blur",
        },
        owner: {
          required: true,
          message: "Please input owner",
          trigger: "blur",
        },
        currency: {
          required: true,
          message: "Please input currency",
          trigger: "change",
        },
        rekening_no: {
          required: true,
          message: "Please input number rekening",
          trigger: "blur",
        },
        balance: {
          required: true,
          message: "Please input balance",
          trigger: "blur",
        },
        swift_code: {
          required: true,
          message: "Please input swift code",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "Please input address",
          trigger: "blur",
        },
      },
      bank: [],
      currency: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
  },
  watch: {
    dataedit() {
      this.initialData();
    },
  },
  mounted() {
    this.fetch();
    this.initialData();
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        date:
          this.mode == "Edit"
            ? moment(this.dataedit.create_dt).format(this.getStandartFormatDate)
            : moment(new Date()).format(this.getStandartFormatDate),
        bank_account_name: this.mode == "Edit" ? this.dataedit.nama_bank : null,
        bank_code: this.mode == "Edit" ? this.dataedit.bank_account_id : null,
        owner: this.mode == "Edit" ? this.dataedit.pemilik : null,
        currency: this.mode == "Edit" ? this.dataedit.currency : null,
        rekening_no: this.mode == "Edit" ? this.dataedit.kode_rekening : null,
        balance: this.mode == "Edit" ? parseInt(this.dataedit.saldo_awal) : 0,
        swift_code: this.mode == "Edit" ? this.dataedit.swift_code : null,
        address: this.mode == "Edit" ? this.dataedit.address : null,
      };
    },
    fetch() {
      this.$store
        .dispatch("FetchDataInput", { auth: this.getAuth })
        .then((res) => {
          this.bank = res.bank_account;
          this.currency = res.currency;
        });
      if (this.id) {
        this.$store
          .dispatch("FetchEditBank", { auth: this.getAuth, params: this.id })
          .then((res) => {
            this.dataedit = res;
            this.mode = "Edit";
          });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.submit = true;
        const data = {
          tlc: this.getAuth.username,
          date: this.form.date,
          bank_account_name: this.form.bank_account_name,
          bank_code: this.form.bank_code,
          owner: this.form.owner,
          currency: this.form.currency,
          rekening_no: this.form.rekening_no,
          address: this.form.address,
          swift_code: this.form.swift_code,
          balance:  this.form.balance,
        };

        let url;
        if (this.mode == "Create") {
          url = "PostBank";
        } else {
          url = "PutBank";
        }

        this.$store
          .dispatch(url, { auth: this.getAuth, payload: data })
          .then((res) => {
            if (this.mode == "edit") {
              this.displayMessage("success-edit");
            } else {
              this.displayMessage("success");
            }
            this.loading.submit = false;
            this.$router.go(-1);
          })
          .catch((err) => {
            this.displayMessageValue("basic-error", err.response.data.message);
            this.loading.submit = false;
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
